import { ValidatorFn } from '@angular/forms';
import { ExtendedFormControl } from '../extended-form-control.class';

export class MultiselectControl extends ExtendedFormControl {

    constructor(name: string, value: Array<string | number> = [], validations: ValidatorFn[] = [], disabled = false) {
        super(name, value, validations, disabled);
    }
}
